import React, { useState } from 'react';
import './Contact.css';

const Contact = ({ darkmodeClass }) => {
  const [name, setName] = useState('');
  const [number, setNumber] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [validNumber, setValidNumber] = useState(true);
  const [touchedFields, setTouchedFields] = useState({});

  const isFormValid = () => {
    const isNameValid = /^[a-zA-Z\s]+$/.test(name) || !name.trim();
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || !email.trim();
    const isNumberValid = validNumber || !number.trim();
    const isMessageValid = message.trim() !== '';

    return isNameValid && isEmailValid && isNumberValid && isMessageValid;
  };

  const getErrorForField = (fieldName) => {
    switch (fieldName) {
      case 'name':
        return touchedFields.name && !/^[a-zA-Z\s]+$/.test(name) && 'Invalid name. Please use only alphabetical characters and spaces.';
      case 'number':
        return touchedFields.number && !validNumber && 'Invalid phone number. Please enter a valid 10-digit number.';
      case 'email':
        return touchedFields.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && 'Invalid email. Please enter a valid email address.';
      default:
        return null;
    }
  };

  const handleInputChange = (field, value) => {
    // Set the field as touched when there is any input
    setTouchedFields((prevTouchedFields) => ({
      ...prevTouchedFields,
      [field]: Boolean(value),
    }));

    // Update the state based on the input field
    switch (field) {
      case 'name':
        setName(value.replace(/[^a-zA-Z\s]/g, ''));
        break;
      case 'number':
        const newNumber = value.replace(/\D/g, '');
        setNumber(newNumber);
        setValidNumber(newNumber.length === 10);
        break;
      case 'email':
        setEmail(value);
        break;
      case 'message':
        setMessage(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isFormValid()) {
      // If the form is not valid, prevent submission
      return;
    }
    // Handle form submission logic (e.g., send data to server)
    console.log('Name:', name);
    console.log('Phone Number:', number);
    console.log('Email:', email);
    console.log('Message:', message);
    // Reset form fields and error messages
    setName('');
    setNumber('');
    setEmail('');
    setMessage('');
    setTouchedFields({});
    // Set submitted to true
    setSubmitted(true);
    // After 5 seconds, reset form and hide thank-you message
    setTimeout(() => {
      console.log('Timeout executed');
      setSubmitted(false);
    }, 5000);
  };

  return (
    <div className={`contact-container1 ${darkmodeClass}`}>
      <div className={`contact-container ${darkmodeClass}`}>
        <h2 className={`${darkmodeClass}`}>Contact Us</h2>
        <form onSubmit={handleSubmit}>
          <label className={`${darkmodeClass}`} htmlFor="name">
            Enter Your Name:<span className="required">*</span>
          </label>
          <input
            type="text"
            id="name"
            value={name}
            placeholder='Enter Your Name'
            onChange={(e) => handleInputChange('name', e.target.value)}
            required
          />
          {getErrorForField('name') && <span className="error-message">{getErrorForField('name')}</span>}

          <label className={`${darkmodeClass}`} htmlFor="number">
            Enter Your Phone Number:<span className="required">*</span>
          </label>
          <input
            type="phone"
            id="number"
            value={number}
            placeholder='Enter Your Mobile Number'
            onChange={(e) => handleInputChange('number', e.target.value)}
            required
          />
          {getErrorForField('number') && <span className="error-message">{getErrorForField('number')}</span>}

          <label className={`${darkmodeClass}`} htmlFor="email">
            Enter Your Email:<span className="required">*</span>
          </label>
          <input
            type="email"
            id="email"
            value={email}
            placeholder='Enter Your Email'
            onChange={(e) => handleInputChange('email', e.target.value)}
            required
          />
          {getErrorForField('email') && <span className="error-message">{getErrorForField('email')}</span>}

          <label className={`${darkmodeClass}`} htmlFor="message">
            Enter Message:<span className="required">*</span>
          </label>
          <textarea
            id="message"
            value={message}
            placeholder='Enter Your Message'
            onChange={(e) => handleInputChange('message', e.target.value)}
            required
          ></textarea>

          <button type="submit" disabled={!isFormValid()}>
            Send Message <i class="fa-solid fa-paper-plane"></i> 
          </button>
        </form>

        {submitted && (
          <div className="thank-you-message">
            Thank you for contacting us!
          </div>
        )}
      </div>
    </div>
  );
};

export default Contact;
